<div class="d-flex flex-column gap-2 h-100">
  <div class="visualization-label">{{ label }}</div>
  <div class="visualization-container" [style.border-color]="borderColor" [style.background-color]="backgroundColor">
    <div class="d-flex justify-content-center">
      <div [style.max-height.rem]="7.688" [style.max-width.rem]="7.688">
        <app-donut-chart [data]="donutChartData" />
      </div>
    </div>
    <app-donut-chart-legend class="h-100" [data]="donutChartData" [showTotalRow]="true" />
  </div>
</div>
